import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ListParams } from '../models/list-params/list-params.model';
import { Asset } from '../models/interactive-activity/interactive-activity.model';

export interface NewInteractiveActivityType {
  title: string;
  slug: string;
  configurationSchema: string;
  worksheetCreationCharacteristics: string;
  enableNoteTaking: boolean;
  isCustomHtml: boolean;
  customHtml?: string; // Only meaningful (and only sent) for custom-HTML types.
  templateAssets?: Asset[]; // Also for custom-HTML types.
  thumbnail?: string | null; // Also for custom-HTML types.
}

@Injectable({
  providedIn: 'root',
})
export class InteractiveActivityTypesService {
  private readonly http = inject(HttpService);

  list(params?: ListParams): Observable<any> {
    return this.http.get('admin/interactive-activity-types', params);
  }

  // Looks up an activity type by its slug (e.g. 'qa').
  get(activitySlug: string): Observable<any> {
    return this.http.get('admin/interactive-activity-types/' + activitySlug);
  }

  // Looks up an activity type by its uuid.
  getByUuid(activityUuid: string): Observable<any> {
    return this.http.get('admin/interactive-activity-types/uuid/' + activityUuid);
  }

  // Creates an activity type; `configurationSchema` is sent as JSON text.
  create(params: NewInteractiveActivityType): Observable<{ interactiveActivityTypeId: string }> {
    return this.http.post('admin/interactive-activity-types', params);
  }

  // Updates an activity type; its slug and isCustomHtml can't change once created.
  update(activityUuid: string, params: Partial<NewInteractiveActivityType>): Observable<void> {
    return this.http.put('admin/interactive-activity-types/uuid/' + activityUuid, params);
  }
}
